module.exports = __webpack_public_path__ + "static/img/interpretive-and-educational.ca3bd55.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/interpretive-and-educational.jpg
// module id = 407
// module chunks = 0